<template>
		<MainLayout>
			<div class="container">
				<div class="box">
					<b-button v-if="$hasPermission('city.add')" class="float-right" @click="newDestination" >Nueva Ciudad</b-button>
					<h2>Ciudades</h2>
					<hr>
					<b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'destinations-index-list') } ">
						<div class="row">
								<b-form-group class="col-2" label="Buscar">
									<b-form-input v-model="filters.search" type="text" />
								</b-form-group>
								<b-form-group class="col-2" label=".">
									<b-button type="submit" variant="primary">Buscar</b-button>
								</b-form-group>
						</div>
					</b-form>
					<AjaxTable
						id="destinations-index-list"
						permission-show="city.show"
						:filters="filters"
						:columns="modelColumns"
						resource="destinations"
					>
						<template v-slot:cell(actions)="row">
							<div class="text-center">
								<b-button @click="(event) => userView(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="info">
									<md-icon icon="edit" />
								</b-button>
								<b-button v-if="$hasPermission('city.delete')" @click="(event) => userDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
									<md-icon icon="delete" />
								</b-button>
							</div>
						</template>
					</AjaxTable>
				</div>
				<hr>
			</div>
			<b-modal
				hide-footer
				id="modal-destinations-view"
				size="lg"
				:title="modalInfo.modelId > 0 ? 'Edición de destino' : 'Nuevo destino'"
				>
				<Single :unableEdit.sync="unableEdit" :model-id="modalInfo.modelId" @modal-id="modalInfo.modelId = $event" modal-id="modal-destinations-view"/>
			</b-modal>
		</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'
import api from '../../../api.js'

export default {
		components: { MainLayout, Single, AjaxTable },
		data(){
				return {
					unableEdit: Boolean,
					modalInfo : {
						modelId:-1,
						title:"Destino",
					},
					filters : {
						search:'',
					},
					modelColumns : [
						{key:'id',label:'ID'},
						{key:'code',label:'Código'},
						{key:'name',label:'Nombre'},
						{key:'stateName',label:'Estado'},
						{key:'countryName',label:'País'},
						{key:'status',label:'Estado'},
						{key:'timeZoneId',label:'Time Zone'},
						{key:'actions',label:'Acciones'},

					],
				}
		},
		methods:{
			userView(item,index,event){
				this.unableEdit = !this.$hasPermission('city.edit')
				this.modalInfo.modelId = item.id
				this.modalInfo.title = 'Datos de usuario'
				this.$root.$emit('bv::show::modal', "modal-destinations-view", event.target)
			},
			newDestination(event){
				this.unableEdit = false
				this.modalInfo.modelId = -1
				this.modalInfo.title = 'Nuevo usuario'
				this.$root.$emit('bv::show::modal', "modal-destinations-view", event.target)
			},
			userDelete(item) {
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						api(this).delete(`/destinations/${item.id}`).then((response) => {

							if (response.data.error) {
								this.$root.showAlert(response.data.message, {variant: 'warning'})
								close()
								return false
							}

							this.$root.showAlert('Registro Eliminado!', {variant: 'warning'})
							this.$root.$emit('bv::refresh::table', 'destinations-index-list')
							this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['destinationsOpts'],forceRefresh: true})
							close()
						}).catch(err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			}
		},
		mounted(){
		}
}
</script>

<style>

</style>
